<template>
  <div class="yh-page">
    <el-card v-loading="loading" :element-loading-text="loadingText">
    <!-- 搜索框 -->
    <div class="search-box">
      <el-input
        type="text"
        v-model.trim="query.search"
        placeholder="搜索快递单号"
        @keyup.enter.native="getData"
        style="width: 300px;"
      />
      &nbsp;
      <el-select id="department" v-model="query.department" placeholder="请选择归属部门" clearable filterable @change="getData">
        <el-option v-for="item in groupNameList" :key="item.id" :label="item.name" :value="item.name"></el-option>
      </el-select>
    </div>
    <el-row>
      <el-col :span="4">
        <el-button type="primary" @click="handleDetail">寄快递</el-button>
        <el-button type="primary" @click="handleUpdate">快递更新</el-button>
      </el-col>
      <el-col :span="6" v-if="showUpload">
        <el-upload ref="upload" class="upload-demo" :multiple="false" :limit="1"
                action=""
                :auto-upload=true
                :accept="accept"
                :headers="headers"
                :http-request="handleUpload">
          <el-button type="primary">账单上传</el-button>
        </el-upload>
      </el-col>
    </el-row>


    <el-table :key="0" :data="expressList" stripe fit highlight-current-row class="w-100" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="waybillNo" label="快递单号" width="180"></el-table-column>
      <el-table-column prop="sender.contact" label="寄件人" width="140"></el-table-column>
      <el-table-column prop="receiver.contact" label="收件人" width="140"></el-table-column>
      <el-table-column prop="department" label="归属部门" width="180"></el-table-column>
      <!-- <el-table-column prop="courierCompany" label="快递公司" width="120"></el-table-column> -->
      <el-table-column prop="status_display" label="状态" width="120">
        <template slot-scope="scope">
          <el-tag :type="statusType[scope.row.orderStatus] || statusType.default">{{ scope.row.status_display }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="220">
        <template slot-scope="scope">
          {{ scope.row.create_time | parseTime("{y}-{m}-{d} {h}:{i}:{s}") }}
        </template>
      </el-table-column>
      <el-table-column label="更新时间" width="220">
        <template slot-scope="scope">
          {{ scope.row.update_time | parseTime("{y}-{m}-{d} {h}:{i}:{s}") }}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="handleView(scope.row.id)">详情</el-button>
          <!-- <el-button type="text">寄送</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <pagination-new ref="pagination" :size.sync="query.limit" :offset.sync="query.offset" :total="total" @updateList="getData"></pagination-new>
  </el-card>

  <el-dialog title="快递信息" :visible.sync="dialogFormVisible">
    <el-form :model="form" :rules="rules" ref="form" label-width="120px">
      <el-form-item label="运单号" prop="name">
        <el-input v-model.trim="form.name" :disabled="action !== 'supplement'"></el-input>
      </el-form-item>
      <el-form-item label="归属部门" prop="departments">
        <el-select id="department" v-model="form.departments" placeholder="请选择归属部门" multiple clearable filterable>
          <el-option v-for="item in groupNameList" :key="item.id" :label="item.name" :value="item.name"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleSupplement()" v-if="action === 'supplement'">补 录</el-button>
      <el-button type="primary" @click="handleSupplement()" v-else>修正部门</el-button>
    </div>
  </el-dialog>
  </div>
</template>

<script>
import PaginationNew from '@/components/PaginationNew'
import { getList, supplementExpress } from '@/api/express';
import { fetchGroupNameList } from '@/api/group'; 
import { importExpressBilling } from '@/api/upload';
import { getToken } from '@/utils/auth';
import { setQueryStorage } from '@/api/user';

export default {
  components: {
    PaginationNew,
  },
  data() {
    return {
      loading: false,
      loadingText: '加载中...',
      accept: '.xls,.xlsx',
      query: { // 分页参数
        search: '',
        department: '',
        limit: 10,
        offset: 0,
      },
      total: 0, // 总条数
      expressList: [],
      groupNameList: [], // 部门列表
      dialogFormVisible: false, // 对话框是否可见
      form: { // 表单数据
        name: '',
        departments: [],
      },
      rules: {
        name: [{required: true, message: '请输入运单号', trigger: 'blur'}],
        departments: [{required: true, message: '请选择', trigger: 'blur'}],
      },
      showUpload: false,
      action: 'supplement', // 操作类型
    };
  },
  computed: {
    statusType() {
      return {
        '9': 'success',
        '1': 'info',
        '2': 'warning',
        default: 'danger'
      }
    },
    headers() { // 请求头
      return {
        'Authorization': `Token ${getToken()}`
      }
    }
  },
  watch: {},
  methods: {
    // 获取快递列表
    getData() {
      this.loading = true;
      getList(this.query).then(response => {
        this.loading = false;
        this.expressList = response.results;
        this.total = response.count;
      }).catch(error => {
        this.loading = false;
        console.error('Error fetching express list:', error);
      });
      window.localStorage.removeItem('query');
    },
    // 跳转到详情页
    handleDetail() {
      setQueryStorage('query', this.query);
      this.$router.push({
        name: 'express_detail',
        params: { 'type': 'create' }
      });
    }, 
    handleView(id) {
      setQueryStorage('query', this.query);
      this.$router.push({
        name: 'express_detail',
        params: { 'type': 'view', 'id': id }
      });
    },
    loadData() {
      fetchGroupNameList() // 调用获取部门列表的方法
      .then(response => {
        this.groupNameList = response; // 将返回的部门列表赋值给 groupNameList
      })
    },
    handleUpdate() {
      if (this.form.name) {
        this.action = 'change';
      }
      else {
        this.action = 'supplement'; 
      }
      this.dialogFormVisible = true; // 打开对话框
    },
    handleSelectionChange(val) {
      this.form.name = '';
      if (val.length > 0) {
        for (let i = 0; i < val.length; i++) {
          this.form.name += val[i].waybillNo + ',';
        }
      }
    },
    handleSupplement() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.$set(this.form, 'department', this.form.departments.join(','));
          this.$set(this.form, 'action', this.action)

          supplementExpress(this.form)
          .then(response => {
            this.$message.success(response.message);
            this.dialogFormVisible = false; // 关闭对话框
            this.getData(); // 刷新列表
          })
          .catch(error => {
              console.error('Error creating express:', error); 
              this.$message.error(error.message);
          })
        }
      })
    },
    handleUpload(param) {
      let fileObj = param.file
      let fd = new FormData()

      fd.append('file', fileObj)
      importExpressBilling(fd)
      .then(res => {
        param.onSuccess(res.message)
        this.$message.success('上传成功！')
      })
      .catch(error => {
        param.onError(error)
        this.$error_message(error)
      })
      .finally(() => {
        this.$refs.upload.clearFiles() // 上传完成后清空文件列表
        this.getData() // 刷新列表
      })
    }
  },
  mounted() {},
  created() {
    this.query = JSON.parse(window.localStorage.getItem('query')) || { // 获取本地存储的查询参数
      search: '',
      department: '',
      limit: 10,
      offset: 0,
    };

    if (this.$perm(['express.add_expressbilling'])) {
      this.showUpload = true;
    }

    this.loadData();
    this.getData();  
  }
};
</script>

<style scoped>
.express-list {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.search-box {
  margin-bottom: 20px;
}

.search-box input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 4px;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

th, td {
  padding: 10px;
  border: 1px solid #ccc;
  text-align: left;
}

th {
  background-color: #f4f4f4;
}

.pagination {
  margin-top: 20px;
  text-align: center;
}

.pagination button {
  padding: 5px 10px;
  margin: 0 5px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.pagination button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
</style>